import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { PageNotFoundComponent } from './not-found.component';
// import  * as Dashboard from './dashboard/index';
import { UnavailableComponent } from './unavailable/unavailable.component';

const routes: Routes =   [
  {
    path: '**',
    redirectTo: '/unavailable'
  },
  {
    path: 'unavailable',
    component: UnavailableComponent
  }
  // {
  //   path: '',
  //   component: Dashboard.MainComponent,
  //   children: [
  //     {
  //       path: ':institutionId/:appType/summary',
  //       component: Dashboard.SummaryComponent,
  //     },
  //     {
  //       path: '',
  //       children: [
  //         {
  //           path: ':appId',
  //           component: Dashboard.InstitutionListComponent,
  //         },
  //         {
  //           redirectTo: 'exam-monitor',
  //           path: '**',
  //         }
  //       ]
  //     },
  //   ]
  // },
  // {
  //   path: '**',
  //   component: PageNotFoundComponent,
  // }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRouteModule { }
